import { useState } from "react";
import { Page } from "../../components/Page";
import {
  useAddChargeAuth,
  useChargeAuthList,
  useChargeAuthMe,
  useRemoveChargeAuth,
  useResetChargeAuth,
} from "./useChargeAuth";

export function ChargeSecurity() {
  const { data: me, isLoading: meLoading } = useChargeAuthMe();
  const isManager = !!me?.isManager;
  const { data: rows = [], isLoading } = useChargeAuthList(isManager);
  const addMutation = useAddChargeAuth();
  const removeMutation = useRemoveChargeAuth();
  const resetMutation = useResetChargeAuth();

  const [email, setEmail] = useState("");
  const [isManagerInput, setIsManagerInput] = useState(false);

  const add = () => {
    if (!email || addMutation.isPending) return;
    addMutation.mutate(
      { email, isManager: isManagerInput },
      {
        onSuccess: () => {
          setEmail("");
          setIsManagerInput(false);
        },
      },
    );
  };

  if (!meLoading && !isManager) {
    return (
      <Page>
        <div className="p-4 flex-1 bg-surface-tertiary">
          <h1 className="text-2xl font-semibold mb-2">Charge Authorization</h1>
          <p className="text-sm text-gray-500">
            You don't have access to manage charge authorization.
          </p>
        </div>
      </Page>
    );
  }

  return (
    <Page>
      <div className="p-4 flex-1 bg-surface-tertiary">
        <h1 className="text-2xl font-semibold mb-4">Charge Authorization</h1>

        <div className="flex gap-2 mb-4">
          <input
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            placeholder="admin@email.com"
            className="px-3 py-2 border rounded-lg text-sm min-w-[260px]"
          />
          <label className="flex items-center gap-1 text-sm">
            <input
              type="checkbox"
              checked={isManagerInput}
              onChange={(e) => setIsManagerInput(e.target.checked)}
            />
            Manager
          </label>
          <button
            onClick={add}
            disabled={addMutation.isPending}
            className="px-4 py-2 rounded-lg bg-black text-white text-sm font-semibold disabled:opacity-50"
          >
            {addMutation.isPending ? "Adding…" : "Add"}
          </button>
        </div>

        {isLoading || meLoading ? (
          <p className="text-sm text-gray-500">Loading…</p>
        ) : (
          <table className="w-full bg-white rounded-lg border border-[#E9E9EB]">
            <thead className="bg-[#F4F4F6] text-left text-sm">
              <tr>
                <th className="px-4 py-3">Email</th>
                <th className="px-4 py-3">Role</th>
                <th className="px-4 py-3">Enrolled</th>
                <th className="px-4 py-3">Actions</th>
              </tr>
            </thead>
            <tbody>
              {rows.map((r) => (
                <tr key={r.id} className="border-t border-[#E9E9EB] text-sm">
                  <td className="px-4 py-3">{r.email}</td>
                  <td className="px-4 py-3">
                    {r.isManager ? "Manager" : "Charger"}
                  </td>
                  <td className="px-4 py-3">{r.enrolledAt ? "Yes" : "No"}</td>
                  <td className="px-4 py-3 flex gap-3">
                    <button
                      onClick={() => resetMutation.mutate(r.id)}
                      disabled={resetMutation.isPending}
                      className="text-amber-700 hover:underline disabled:opacity-50"
                    >
                      Reset authenticator
                    </button>
                    <button
                      onClick={() => removeMutation.mutate(r.id)}
                      disabled={removeMutation.isPending}
                      className="text-red-600 hover:underline disabled:opacity-50"
                    >
                      Remove
                    </button>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        )}
      </div>
    </Page>
  );
}

export default ChargeSecurity;
